// extracted by mini-css-extract-plugin
export default {"contenido":"precios_contenido__UylzE","seccion":"precios_seccion__xiC6V","nota":"precios_nota__aUbYT","seccionAviso":"precios_seccionAviso__X50RO"};